/**
 * Visual treatment for the Gap Coverage card's coverage percentage.
 *
 * Threshold tiers follow DEC-056 (binary honest signaling):
 *   - <33%    -> rose   (severe shortage)
 *   - 33-99%  -> gold   (partial coverage; text uses gold-dark for AA contrast)
 *   - >=100%  -> green2 (gap covered; '+N% surplus' suffix when over-produced)
 *
 * Color token names match the project's palette (`rose`/`gold`/
 * `gold-dark`/`green2`) -- the same severity tokens used by Map
 * popups, and the Rankings severity pill. Not the Tailwind default
 * scale.
 *
 * Kept in a separate module from `GapCoverageCard.tsx` so the
 * component file only exports the component itself, satisfying the
 * `react-refresh/only-export-components` lint rule the project
 * enforces.
 */
export interface CoverageStyle {
  readonly textClass: string;
  readonly barClass: string;
  readonly label: string;
}

export function getCoverageStyle(pct: number): CoverageStyle {
  if (pct >= 100) {
    return {
      textClass: 'text-green2',
      barClass: 'bg-green2',
      label:
        pct > 100 ? `Gap fully covered (+${pct - 100}% surplus)` : 'Gap fully covered',
    };
  }
  if (pct >= 33) {
    return {
      textClass: 'text-gold-dark',
      barClass: 'bg-gold',
      label: 'Partial coverage',
    };
  }
  return {
    textClass: 'text-rose',
    barClass: 'bg-rose',
    label: 'Severe shortage',
  };
}
